import React from 'react'
import App from './App'
import './index.css'
import ReactDom from 'react-dom'
import './favicon.ico'

ReactDom.render(<App/>, document.querySelector("#root"))